import { render, staticRenderFns } from "./Talent.vue?vue&type=template&id=427e0628&scoped=true"
import script from "./Talent.vue?vue&type=script&lang=ts"
export * from "./Talent.vue?vue&type=script&lang=ts"
import style0 from "./Talent.vue?vue&type=style&index=0&id=427e0628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427e0628",
  null
  
)

export default component.exports